<template>
  <div class="__filter" :class="{ _open: isMenuOpen }" v-on-click-outside="onMenuClose">
    <a href="#" class="_filter__btn" @click.prevent="onMenuToggle()">
      <i class="material-icons">filter_list</i>
    </a>
    <div class="_filter__list">
      <h4>Assignee:</h4>
      <div class="_filter__item" v-for="(_item, _index) in list" :key="_index">
        <md-checkbox v-model="selectedItems" :value="_item" @change="onFilterChange">{{ _item }}</md-checkbox>
      </div>
      <div class="_filter__item">
        <a class="_filter__reset" href="#" @click.prevent="onFilterReset">Reset Filters</a>
      </div>
    </div>
  </div>
</template>

<script>
import { directive as OnClickOutside } from "vue-clickaway";

export default {
  directives: {
    OnClickOutside
  },

  props: {
    items: {
      type: Array[Object],
      required: false,
      default: () => []
    }
  },

  data() {
    return {
      isMenuOpen: false,
      filterdItems: [],
      selectedItems: []
    };
  },
  computed: {
    list() {
      if (!this.items || !this.items.length || !this.items[0].assigneeList) {
        return [];
      }
      return this.items[0].assigneeList;
    }
  },

  methods: {
    onFilterReset() {
      this.selectedItems = [...this.items[0].assigneeList];
      this.onFilterChange();
    },

    onFilterChange() {
      this.$emit("filter", this.selectedItems);
    },

    onMenuToggle() {
      this.isMenuOpen = !this.isMenuOpen;
    },

    onMenuClose() {
      this.isMenuOpen = false;
    }
  },

  watch: {
    items: {
      handler: function(newVal, oldVal) {
        if (this.items && this.items.length && this.items[0].assigneeList) {
          this.selectedItems = [...this.items[0].assigneeList];
        }
        this.onFilterChange();
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
.__filter {
  z-index: 100;
  position: relative;
  top: 25px;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 2rem;
  color: #555;
  font-size: 14px;
}

._filter__btn {
  display: inline-block;
  margin-right: 1rem;
  padding: 0.1rem;
  background-color: #eee;
  border: 1px solid #ddd;
  border-radius: 4px;
}

._filter__list {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  max-height: 380px;
  overflow: auto;
  top: 100%;
  right: 0.8rem;
  margin-top: 5px;
  padding: 1rem;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);
  transition: opacity 0.15s visibility 0.15s;
  &::before {
    content: "";
    position: absolute;
    bottom: 100%;
    right: 8px;
    border: 8px solid transparent;
    border-bottom-color: #fff;
  }
}

._open ._filter__list {
  opacity: 1;
  visibility: visible;
}

._filter__item {
  padding: 0.3rem 0;
  &:last-child {
    padding-bottom: 0;
  }
  .md-checkbox {
    margin: 0;
  }
  .md-checkbox-label {
    color: inherit;
  }
}

._filter__reset:hover {
  text-decoration: underline;
}

._filter__list h4 {
  font-size: 15px;
  margin: 0px 0px 5px;
  font-weight: 500;
}
</style>